module.exports = __webpack_public_path__ + "img/logo-menu-branco.6858dcae.png";